module.exports = __webpack_public_path__ + "r-v3/img/smile_white.112f8108.svg";